// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-box {
  border-radius: 8px;
}

.salesMetricContainer {
  max-height: 38rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.arrow-right {
  position: absolute;
  top: 50%;
  right: -12px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 15px 0 15px 15px;
}

.bg-blue {
  background-color: #49679a;
}

.bg-blue-arrow {
  border-color: transparent transparent transparent #49679a;
}

.bg-purple {
  background-color: #7e57c2;
}

.bg-purple-arrow {
  border-color: transparent transparent transparent #7e57c2;
}

.bg-light-blue {
  background-color: #29b6f6;
}

.bg-light-blue-arrow {
  border-color: transparent transparent transparent #29b6f6;
}

.bg-teal {
  background-color: #26a69a;
}

.bg-teal-arrow {
  border-color: transparent transparent transparent #26a69a;
}

.bg-green {
  background-color: #66bb6a;
}

.text-white {
  color: #ffffff;
}

h5 {
  font-size: small;
  font-weight: bolder;
}

h2 {
  font-size: x-large;
}

.summaryBox {
  width: auto;
}

.cardBottomBand {
  background-color: darkgray;
  font-size: smaller;
  color: black !important;
  position: relative;
  bottom: -14px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.summaryTitle {
  font-size: smaller;
  font-weight: lighter;
}`, "",{"version":3,"sources":["webpack://./src/app/home/sales-metrics-dashboard/sales-metrics-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,+BAAA;EACA,8BAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;AACF","sourcesContent":[".custom-box {\n  border-radius: 8px;\n}\n\n.salesMetricContainer {\n  max-height: 38rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.arrow-right {\n  position: absolute;\n  top: 50%;\n  right: -12px;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 15px 0 15px 15px;\n}\n\n.bg-blue {\n  background-color: #49679a;\n}\n\n.bg-blue-arrow {\n  border-color: transparent transparent transparent #49679a;\n}\n\n.bg-purple {\n  background-color: #7e57c2;\n}\n\n.bg-purple-arrow {\n  border-color: transparent transparent transparent #7e57c2;\n}\n\n.bg-light-blue {\n  background-color: #29b6f6;\n}\n\n.bg-light-blue-arrow {\n  border-color: transparent transparent transparent #29b6f6;\n}\n\n.bg-teal {\n  background-color: #26a69a;\n}\n\n.bg-teal-arrow {\n  border-color: transparent transparent transparent #26a69a;\n}\n\n.bg-green {\n  background-color: #66bb6a;\n}\n\n.text-white {\n  color: #ffffff;\n}\n\nh5 {\n  font-size: small;\n  font-weight: bolder;\n}\n\nh2 {\n  font-size: x-large;\n}\n\n.summaryBox {\n  width: auto;\n}\n\n.cardBottomBand {\n  background-color: darkgray;\n  font-size: smaller;\n  color: black !important;\n  position: relative;\n  bottom: -14px;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.summaryTitle {\n  font-size: smaller;\n  font-weight: lighter;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
